import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { MEDIAS_END_POINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { RequestDTO, ResponseDTO } from "interface";
import { mediasManagementFilter, mediaType } from "../type";

type requestType = RequestDTO<mediasManagementFilter>;
const getMedias = async (
  data: requestType
): Promise<ResponseDTO<mediaType[]>> => {
  const res = await instance.post(
    `${MEDIAS_END_POINTS.grid}`,
    data
  );

  return res.data;
};

type UseGetMediasOptions = UseQueryOptions<
  ResponseDTO<mediaType[]>,
  unknown,
  ResponseDTO<mediaType[]>
>;
export const useGetMedias = (
  params: requestType,
  config?: UseGetMediasOptions
) => {
  return useQuery({
    queryKey: [
      MEDIAS_END_POINTS.grid,
      params.page,
      params.pageSize,
      ...(params.inputParams.filters ? params.inputParams.filters : []),
    ],
    queryFn: () => getMedias(params),
    ...config,
  });
};
